import { mockStages, mockWorkflows } from '@/lib/demo-data/workflows';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

export interface WorkflowListItemApi {
  id: number;
  disputeTypeId: number;
  disputeTypeName: string;
  name: string;
  description: string | null;
  status: string;
  createdByUserId: number | null;
  createdByUserName: string | null;
  createdAt: string;
  updatedAt: string;
  stageCount: number;
  transitionCount: number;
}

export interface WorkflowStageApi {
  id: number;
  workflowId: number;
  name: string;
  description: string | null;
  sortOrder: number;
  color: string | null;
  icon: string | null;
  properties: string | null;
  notifications: string | null;
  requiredFields: string | null;
  allowedActions: string | null;
  createdAt: string;
  updatedAt: string;
}

export function useWorkflowsList() {
  const { apiGet } = useApi();

  return useModeAwareQuery<WorkflowListItemApi[], Error>(
    ['workflows'],
    async ({ signal }) => {
      return apiGet<WorkflowListItemApi[]>('/api/v1/settings/workflows', undefined, signal);
    },
    mockWorkflows,
    { staleTime: 60 * 1000, refetchOnWindowFocus: false },
  );
}

export function useWorkflowStages(workflowId: number | null) {
  const { apiGet } = useApi();

  return useModeAwareQuery<WorkflowStageApi[], Error>(
    ['workflow-stages', workflowId],
    async ({ signal }) => {
      if (!workflowId) return [];
      return apiGet<WorkflowStageApi[]>(`/api/v1/settings/workflows/${workflowId}/stages`, undefined, signal);
    },
    mockStages,
    {
      enabled: !!workflowId,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}
